import React, { useEffect, useContext, useState } from "react"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
import * as keywordMapping from "../../../static/nvestKeyMapping.json"
import { concatSeries } from "async"
import { productRenderChecker } from "../services/helperFunctions"
import {JourneyContext} from "../context/journeyContext"
import styled from "styled-components"
import Parser from 'html-react-parser';


const ReadMore = styled.div`
  .read-more-state {
    display: none;
  }
  
  .read-more-target {
    opacity: 0;
    max-height: 0;
    font-size: 0;
  }
  
  .read-more-state:checked ~ .read-more-wrap .read-more-target {
    opacity: 1;
    font-size: inherit;
    max-height: 999em;
    .second-line{
      margin-top: 1rem;
      display: block;
    }
  }
  
  .read-more-state:not(:checked) ~ .read-more-trigger:before {
    content: '...';
  }
  .read-more-state:not(:checked) ~ .read-more-trigger:after {
    content: ' Read more';
    text-decoration: underline;
  }
  
  .read-more-state:checked ~ .read-more-trigger:before {
    content: 'Read less';
    text-decoration: underline;

  }

  
  .read-more-trigger {
    cursor: pointer;
    color:inherit;
    /* text-decoration: underline; */
}`

export default function ComponentReadMore(props) {
  console.log(props);
 const{ index,color }= props
    return <>
      <ReadMore style={{color:color}} >
        <input type="checkbox" className="read-more-state" id={`post-${index}`} />
        {Parser(props.html)}
        
        <label for={`post-${index}`} className="read-more-trigger"></label>
      </ReadMore>
    </>
}